import {useChainListQuery} from "./api/wallet";
import useLocalStore from "../store/useLocalStore";
import {useMemo, useState} from "react";
import {useModal} from "../context/ModalContext";
import {Button, Radio} from "../ui";
import {createPublicClient, formatUnits, http, parseUnits} from "viem";
import {useDownMd} from "./useLayout";
import {FormattedMessage, useIntl} from "react-intl";

export default function useMatchChain() {
    const chainListQuery = useChainListQuery()
    const modal = useModal()
    const intl = useIntl()
    const {chainId: storeChainId, setChainId} = useLocalStore()
    const chainId = useMemo(() => {
        if (!chainListQuery.data || !chainListQuery.data.length) {
            return null
        }
        if (chainListQuery.data.find((item) => item.id === storeChainId)) {
            return storeChainId
        }
        return chainListQuery.data[0].id
    }, [storeChainId, chainListQuery.data])

    const chain = useMemo(() => {
        if (!chainListQuery.data || !chainListQuery.data.length) {
            return null
        }
        return chainListQuery.data.find((item) => item.id === chainId)
    }, [chainId, chainListQuery.data])

    const explorerLink = (url: string) => {
        const explorer = chain?.blockExplorers.default.url as string
        return explorer.lastIndexOf('/') === explorer.length - 1 ? explorer + url : explorer + '/' + url
    }

    function ChangeNetwork({
                               close,
                           }: {
        close: () => void
    }) {
        const {chainId: storeChainId, setChainId} = useLocalStore()
        const [selectedChainId, setSelectedChainId] = useState(storeChainId)
        const isDownMd = useDownMd()
        return <div className={`matchid-change-network-box`}>
            <div className={`matchid-change-network-list`}>
                {
                    chainListQuery.data?.map((item, index) => {
                        return <div key={index} onClick={() => setSelectedChainId(item.id)}
                                    className={`matchid-change-network-item  ${selectedChainId == item.id ? 'matchid-change-network-selected' : ''}`}>
                            <div className={`matchid-change-network-item-content`}>
                                <img src={item.iconUrl} className={`matchid-change-network-item-icon`}/>
                                <span className={"matchid-change-network-item-name"}>{item.name}</span>
                            </div>
                            <Radio checked={selectedChainId === item.id} size={isDownMd ? 18 :24}/>
                        </div>
                    })
                }
            </div>
            <Button size={"lg"} highlight onClick={() => {
                setChainId(selectedChainId || 0)
                close()
            }} block><FormattedMessage id={"confirm"}/></Button>
        </div>
    }

    const showChangeNetwork = () => {
        modal.open({
            title: intl.formatMessage({id: 'changeNetwork'}),
            content: ChangeNetwork
        })
    }

    const publicClient = useMemo(() => {
        if (!chain) {
            return null
        }
        return createPublicClient({
            chain,
            transport:http()
        })
    }, [chain])

    return {
        list: chainListQuery.data,
        chainId,
        setChainId,
        chain,
        explorerLink,
        showChangeNetwork,
        publicClient,
        formatUnits: (value: bigint) => {
            return formatUnits(value, chain?.nativeCurrency.decimals || 18)
        },
        parseUnits: (value: string) => {
            return parseUnits(value, chain?.nativeCurrency.decimals || 18)
        }
    }
}